import { combineReducers } from 'redux';

import player from './player/reducer';

export default combineReducers({ player });
